import { Injectable } from '@angular/core';
import { ActionCell } from '@material-library';
import { BehaviorSubject } from 'rxjs';

export interface RootLayoutConfig {
  appBar?: any;
  isCustomLayout?: boolean;
  pageTitle?: string;
  useBreadcrumbItems?: boolean;
  linkTitle?: string;
  linkSubTitle?: string;
  breadcrumbActions?: ActionCell;
}

@Injectable({
  providedIn: 'root',
})
export class RootLayoutConfigService {
  private dataSource = new BehaviorSubject<RootLayoutConfig>(null);
  public currentData$ = this.dataSource.asObservable();

  private errcodeSource = new BehaviorSubject<number | null>(null);
  public errcode$ = this.errcodeSource.asObservable();
  public linkRootDirectory = '';

  public updateConfig(data: RootLayoutConfig): void {
    this.dataSource.next(data);
  }

  public setErrCode(code: number | null): void {
    this.errcodeSource.next(code);
  }
  public patchConfig(data: RootLayoutConfig): void {
    this.dataSource.next({ ...this.dataSource.getValue(), ...data });
  }
}
